// Real Māori design elements from uploaded assets
// "mā" = white versions (for dark backgrounds, use with mix-blend-mode: screen)
// "pango" = black versions (for light backgrounds, use with mix-blend-mode: multiply)

const ASSETS = {
  nihoMa: "https://customer-assets.emergentagent.com/job_tangata-hub/artifacts/sca9rlrc_niho_element_ma_02.jpg",
  koruMa: "https://customer-assets.emergentagent.com/job_tangata-hub/artifacts/gvxu9k74_Koru_pattern_ma%C6%92.jpg",
  koruPango: "https://customer-assets.emergentagent.com/job_tangata-hub/artifacts/8irkffkh_Koru_pattern_pango%C6%92.jpg",
  nihoPango: "https://customer-assets.emergentagent.com/job_tangata-hub/artifacts/6sxwzdrr_niho_element_pango.jpg",
  nihoPango02: "https://customer-assets.emergentagent.com/job_tangata-hub/artifacts/o4eph9ea_niho_element_pango_02.jpg",
  nihoTaniwhaPango: "https://customer-assets.emergentagent.com/job_tangata-hub/artifacts/wtip4yat_niho_taniwha_pattern_pango%C6%92.jpg",
};

// Section divider using niho taniwha pattern - for light backgrounds (black pattern)
export function NihoDividerDark({ className = "" }) {
  return (
    <div className={`w-full ${className}`} data-testid="niho-divider">
      <img
        src={ASSETS.nihoTaniwhaPango}
        alt=""
        aria-hidden="true"
        className="w-full max-h-16 sm:max-h-24 object-contain"
        style={{ mixBlendMode: "multiply" }}
      />
    </div>
  );
}

// Section divider for dark backgrounds (white pattern)
export function NihoDividerLight({ className = "" }) {
  return (
    <div className={`w-full ${className}`} data-testid="niho-divider-light">
      <img
        src={ASSETS.nihoMa}
        alt=""
        aria-hidden="true"
        className="w-full max-h-16 sm:max-h-24 object-contain"
        style={{ mixBlendMode: "screen" }}
      />
    </div>
  );
}

// Koru accent element for dark backgrounds
export function KoruAccentLight({ className = "", style = {} }) {
  return (
    <img
      src={ASSETS.koruMa}
      alt=""
      aria-hidden="true"
      className={`pointer-events-none ${className}`}
      style={{ mixBlendMode: "screen", ...style }}
    />
  );
}

// Koru accent element for light backgrounds
export function KoruAccentDark({ className = "", style = {} }) {
  return (
    <img
      src={ASSETS.koruPango}
      alt=""
      aria-hidden="true"
      className={`pointer-events-none ${className}`}
      style={{ mixBlendMode: "multiply", ...style }}
    />
  );
}

// Niho accent element for light backgrounds
export function NihoAccentDark({ className = "", style = {} }) {
  return (
    <img
      src={ASSETS.nihoPango02}
      alt=""
      aria-hidden="true"
      className={`pointer-events-none ${className}`}
      style={{ mixBlendMode: "multiply", ...style }}
    />
  );
}

export default ASSETS;
